angular.module('dnecom')
    .controller('IntegrationsXomatorSettingsController', ["$scope", "$http", "$window", "notifications", function($scope, $http, $window, notifications) {
        $scope.token = (TemplateData.value('token') || '').replace(/"/g, '');
        $scope.settings = TemplateData.value('settings');

        $scope.settings.defaultPriceMarkup = parseInt($scope.settings.defaultPriceMarkup || 0);

        $scope.authorize = function() {
            $http
                .post(
                    Routing.generate('xomator_authorize'),
                    {
                       token: $scope.token
                    }
                )
                .then(
                    function(response) {
                        if (!response.data.success) {
                            notifications.danger(response.data.message || 'Failed to authorize.');
                            return;
                        }

                        $scope.settings.token = $scope.token;

                        notifications.success('xOmator authorized successfully.');
                    },
                    function() {
                        notifications.danger('Request error.');
                    }
                )
            ;
        };

        $scope.denyAuth = function() {
            $window.close();
        };

        $scope.saveSettings = function() {
            $http
                .post(
                    Routing.generate('xomator_update_settings'),
                    {
                        'settings': $scope.settings
                    }
                )
                .then(
                    function(response) {
                        if (!response.data.success) {
                            notifications.danger(response.data.message || 'Failed to save settings.');
                            return;
                        }

                        notifications.success('Settings updated successfully.');

                        window.location = Routing.generate('integrations_by_typegroup', {typeGroup: 'product-fulfillment'});
                   },
                    function() {
                        notifications.danger('Request error.');
                    }
                )
            ;
        };
    }])
;
